@if (!isViewOnly) {
    @if (!iconView) {
        @if (!isUsingComment) {
            <button
                aria-label="Delete" 
                tabindex="-1" 
                class="delete-btn" 
                (click)="
                    $event.stopPropagation(); 
                    deleteRecord();
                "
            >
                <fa-icon 
                    [icon]="faIconName.faTrashCan" 
                    class="trash-can"
                ></fa-icon>
            </button>
        } @else {
            <button 
                aria-label="Delete" 
                tabindex="-1"
                class="delete-btn" 
                (click)="
                    $event.stopPropagation(); 
                    openModal();
                "
            >
                <fa-icon 
                    [icon]="faIconName.faTrashCan" 
                    class="trash-can"
                ></fa-icon>
            </button>
        }
    } @else {
        @if (!isUsingComment) {
            <fa-icon 
                [icon]="faIconName.faTrashCan" 
                class="trash-can text-danger"
                tabindex="-1" 
                (click)="
                    $event.stopPropagation(); 
                    deleteRecord();
                "
            ></fa-icon>
        } @else {
            <fa-icon        
                [icon]="faIconName.faTrashCan" 
                class="trash-can text-danger" 
                tabindex="-1"
                (click)="
                    $event.stopPropagation(); 
                    openModal();
                "
            ></fa-icon>
        }
    }
}